module.exports = __webpack_public_path__ + "img/award-icon-1.650c9bb.png";